import { request } from './repository';
import _ from 'lodash';

import { defaultLocation, defaultCity } from '../constants/appInfo';

const addressRepository = {
    local: {
        uf: defaultLocation,
        city: defaultCity
    },
    findZipcode(q, scope = 'zipcode') {
        return request.get('zipcodes/addresses', {
            q: q,
            scope: scope
        });
    },
    getStates() {
        return request.get('states');
    },
    getCities(uf) {
        return request.get(`states/${uf}/cities`);
    },
    getNeighborhoods(city_id) {
        return request.get(`neighborhoods/${city_id}`);
    },
    updateAddress(id, data){
        return request.put(`address/${id}`, data)
    }
}

export default addressRepository;
